import { urls } from '@/util/config';
import auth from '@/util/auth';
import store from '@/store';

export default {
    export(context, {
        format,
        type,
    }) {
        return new Promise((resolve) => {
            const params = Object.assign(
                {
                    format,
                    type,
                },
                store.state.globalFilters,
                store.state.chartFilters,
                store.state.chartViews,
                { currentTab: store.state.currentTab },
            );

            const config = {
                headers: auth.getAuthHeader(),
                responseType: 'arraybuffer',
                params,
            };
            console.log(params);
            const getUrl = `${urls.EXPORT_URL}`;

            context.$http.get(getUrl, config).then((res) => {
                const blob = new Blob([res.data], { type: res.headers.get('content-type') });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'KPMG Reporting';
                link.click();
                resolve();
            });
        });
    },
};



// WEBPACK FOOTER //
// ./src/util/pageExport.js